import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  image, 
  url, 
  type = 'website',
  structuredData = null 
}) => {
  const defaultTitle = "NABAZAT AL QALB";
  const defaultDescription = "NABAZAT AL QALB is a premier medical supplies company in Erbil, Iraq. We provide high-quality medical equipment, pharmaceuticals, and healthcare solutions to hospitals, clinics, and healthcare professionals across Iraq.";
  const defaultKeywords = "medical supplies, healthcare, pharmaceuticals, medical equipment, Erbil, Iraq, hospitals, clinics, medical devices, healthcare solutions, NABAZAT AL QALB";
  const defaultImage = "https://nabazatalqalb.com/logo512.png";
  const defaultUrl = "https://nabazatalqalb.com";

  const pageTitle = title ? `${title} | NABAZAT AL QALB` : defaultTitle;
  const pageDescription = description || defaultDescription;
  const pageKeywords = keywords || defaultKeywords;
  const pageImage = image || defaultImage;
  const pageUrl = url || defaultUrl;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{pageTitle}</title>
      <meta name="title" content={pageTitle} />
      <meta name="description" content={pageDescription} />
      <meta name="keywords" content={pageKeywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={pageImage} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={pageUrl} />
      <meta property="twitter:title" content={pageTitle} />
      <meta property="twitter:description" content={pageDescription} />
      <meta property="twitter:image" content={pageImage} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={pageUrl} />
      
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO; 